import { toast } from '@hivebrite/design-system/Toast';

import { ACTIONS } from '../constants/actions';
import { deleteRequest, saveRequest } from '../requests/guests';

export const api = ({ currentUser, updateCurrentUser }) => {
  const deleteGuest = (payload) => (_, dispatch) => {
    const { guest } = payload;

    if (guest.guest_id) {
      return deleteRequest(currentUser.id, guest.guest_id).then(() =>
        dispatch({ type: ACTIONS.DELETE, payload: { guest } }),
      );
    }

    dispatch({ type: ACTIONS.DELETE, payload: { guest } });
  };

  const saveGuests = () => async (getState, dispatch) => {
    const eventGuests = getState();

    if (eventGuests.length === 0) {
      return;
    }

    try {
      const {
        data: { guests },
      } = await saveRequest(currentUser.id, eventGuests);

      updateCurrentUser({ ...currentUser, event_guests: { guests } });

      dispatch({ type: ACTIONS.SAVE, payload: { guests } });
    } catch (e) {
      if (e?.response?.status === 422) {
        toast.error(
          e?.response?.data?.errors?.[0] || __('Sorry, an error occurred'),
        );
      }
    }
  };

  const update = (payload) => ({ type: ACTIONS.UPDATE, payload });
  const create = (payload) => ({ type: ACTIONS.CREATE, payload });

  return {
    delete: deleteGuest,
    update,
    saveGuests,
    create,
  };
};
